module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMzY3MTIyNDczYmM5N2VlOWQzZmMzNWZiYmU3NzljODUucG5nIjs="